.title {
    color: var(--sidebar-primary);
    text-align: center;
    font-family: 'Doyle', 'Georgia', 'sans-serif';
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: 48px;
    max-width: 400px;
}

@media (max-width: 1192px) {
    .subtitle span {
        font-weight: 400;
        font-size: 13px;
        line-height: 17px;
    }

    .icon svg {
        width: 16px;
        height: 16px;
    }
}
